/**
 * ============================================================================
 * SEARCHSPRING DRAWER (CSS-Only Approach)
 * ============================================================================
 * 
 * Uses CSS to position SearchSpring sidebar as a drawer overlay.
 * No HTML manipulation - sidebar stays in original DOM location.
 * This preserves ALL SearchSpring event listeners and functionality.
 * ============================================================================
 */

(function() {
  'use strict';

  function initDrawer() {
    const drawer = document.getElementById('SearchSpringFilterDrawer');
    if (!drawer) return;
    // Guard: initDrawer runs at ready, again on a 2s retry, and on theme
    // editor section re-renders — bind each drawer element exactly once.
    if (drawer.dataset.ssDrawerBound === '1') return;
    drawer.dataset.ssDrawerBound = '1';

    let lastOpener = null;

    function setExpanded(value) {
      document.querySelectorAll('.js-drawer-open-searchspring-filters').forEach(btn => {
        btn.setAttribute('aria-expanded', value ? 'true' : 'false');
      });
    }

    // Simple function to open drawer (just add class)
    function openDrawer(e) {
      if (e) e.preventDefault();
      lastOpener = e && e.currentTarget && e.currentTarget.focus ? e.currentTarget : document.activeElement;
      document.body.classList.add('searchspring-drawer-open');
      document.documentElement.classList.add('searchspring-drawer-open');
      setExpanded(true);
      const closeBtn = drawer.querySelector('.js-drawer-close-searchspring');
      if (closeBtn) closeBtn.focus();
    }

    // Simple function to close drawer (just remove class)
    function closeDrawer(e) {
      if (e) e.preventDefault();
      document.body.classList.remove('searchspring-drawer-open');
      document.documentElement.classList.remove('searchspring-drawer-open');
      setExpanded(false);
      if (lastOpener && lastOpener.focus) lastOpener.focus();
    }

    // Handle open button clicks
    const openButtons = document.querySelectorAll('.js-drawer-open-searchspring-filters');
    openButtons.forEach(openButton => {
      openButton.addEventListener('click', openDrawer);
    });

    // Handle close button clicks
    const closeButton = drawer.querySelector('.js-drawer-close-searchspring');
    if (closeButton) {
      closeButton.addEventListener('click', closeDrawer);
    }

    // Close drawer when clicking backdrop (outside the sidebar) — bound once
    // per page: section re-renders replace the drawer element (new init) but
    // these document-level listeners resolve everything via live queries.
    if (window.__ssDrawerDocBound) { return; }
    window.__ssDrawerDocBound = true;
    document.addEventListener('click', function(e) {
      if (document.body.classList.contains('searchspring-drawer-open')) {
        const sidebar = document.getElementById('searchspring-sidebar');
        
        if (sidebar) {
          // Check if click is outside the sidebar
          const clickedInsideSidebar = sidebar.contains(e.target);
          
          // Don't close if clicking the open button (would immediately close)
          const isOpenButton = e.target.closest('.js-drawer-open-searchspring-filters');

          // Don't close on clicks inside the drawer's own header overlay —
          // its title/close bar sits outside #searchspring-sidebar, and a
          // mis-tap on the 90vw header would otherwise dismiss the drawer.
          const isDrawerHeader = e.target.closest('#SearchSpringFilterDrawer');

          // Close if clicked outside the sidebar (on backdrop)
          if (!clickedInsideSidebar && !isOpenButton && !isDrawerHeader) {
            closeDrawer(e);
          }
        }
      }
    });

    // Close drawer on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && document.body.classList.contains('searchspring-drawer-open')) {
        closeDrawer(e);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }

  // Retry after delay
  setTimeout(initDrawer, 2000);

  // Theme editor section re-renders replace the drawer element
  document.addEventListener('shopify:section:load', initDrawer);

})();
